import HeadlessOptions from "./interfaces/HeadlessOptions";
import { PaintCrop } from "./core/PaintCrop";
import Result from "./interfaces/Result";
import Model from "./core/Model";
import DefaultPayload from "./core/DefaultPayload";

export function generate(options: HeadlessOptions): Promise<Result> {
    return new Promise(function(resolve, reject) {
        const canvas = document.createElement("canvas");

        const payload = options.payload || DefaultPayload;

        let model = new Model(
            payload, options.sourceImage.width, options.sourceImage.height, options.cropWidth, options.cropHeight
        );
        let scale: number;

        if (options.fullResolution) {
            let size = model.getFullResolutionSize(options.maxWidth, options.maxHeight);
            canvas.width = size.width;
            canvas.height = size.height;
            scale = size.width / options.cropWidth;
        } else {
            scale = 1;
            canvas.width = options.cropWidth;
            canvas.height = options.cropHeight;
        }

        PaintCrop(canvas, options.sourceImage, model, 0, 0, scale);

        resolve({
            payload: options.payload,
            imageDataURL: canvas.toDataURL(),
            imageWidth: canvas.width,
            imageHeight: canvas.height
        });
    });
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/image-inline-editor/Headless.ts
 **/